import { FormControlLabel, Typography, Checkbox } from "@mui/material";

import makeStyles from "@mui/styles/makeStyles";

import { palette } from "../../../theme/palette";

import { View } from "../../View";
import { MaskedTextField } from "../../MaskedTextField";

const useStyles = makeStyles({
  container: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
  },
  topContainer: {
    display: "flex",
    padding: "1rem 2.5rem",
    gap: "2rem",
  },
  bottomContainer: {
    display: "flex",
    flexDirection: "column",
    padding: "0rem 0.5rem",
    margin: "1rem 0rem 0rem 0rem",
    minHeight: "5rem",
  },
  additionalMinutesContainer: {
    width: "7.5rem",
  },
  row: {
    display: "flex",
  },
  rowHeader: {
    width: "9rem",
    textAlign: "right",
  },
  rowValue: {
    width: "5rem",
    margin: "-0.25rem 1rem 1.25rem 1rem",
  },
  formCheckbox: { paddingLeft: "0.5rem" },
  formCheckboxLabel: {
    color: palette.grey,
    fontSize: "13px",
  },
});

export const RouteManagementModalContent = ({
  routeConfig,
  route,
  onChange,
  onRoadSpeedChange,
  disabled,
  errors,
}) => {
  const styles = useStyles();

  return (
    <View className={styles.container}>
      <View className={styles.topContainer}>
        <View className={styles.additionalMinutesContainer}>
          <MaskedTextField
            mask={"99:99"}
            value={route["additionalMinutes"]}
            name={"additionalMinutes"}
            label={"Additional Minutes"}
            disabled={disabled}
            error={errors["additionalMinutes"]}
            onChange={onChange}
          />
        </View>
        <FormControlLabel
          className={styles.formCheckbox}
          control={
            <Checkbox
              color={"default"}
              checked={route["useToll"]}
              name={"useToll"}
              onChange={(e) =>
                onChange({
                  ...e,
                  target: {
                    ...e.target,
                    name: "useToll",
                    value: !!e.target.checked,
                  },
                })
              }
              disabled={disabled}
            />
          }
          label={
            <Typography className={styles.formCheckboxLabel}>
              Use Toll
            </Typography>
          }
        />
        <FormControlLabel
          className={styles.formCheckbox}
          control={
            <Checkbox
              color={"default"}
              checked={route["useFerry"]}
              name={"useFerry"}
              onChange={(e) =>
                onChange({
                  ...e,
                  target: {
                    ...e.target,
                    name: "useFerry",
                    value: !!e.target.checked,
                  },
                })
              }
              disabled={disabled}
            />
          }
          label={
            <Typography className={styles.formCheckboxLabel}>
              Use Ferry
            </Typography>
          }
        />
      </View>
      <View className={styles.bottomContainer}>
        {route.roadSpeeds.map(({ roadCode, description, urban, rural }) => {
          return (
            <View className={styles.row}>
              <View className={styles.rowHeader}>{`${description}:`}</View>
              <View className={styles.rowValue}>
                <MaskedTextField
                  mask={"99"}
                  value={urban}
                  name={`${roadCode}-urban`}
                  label={"Urban MPH"}
                  disabled={disabled}
                  error={errors[`${roadCode}-urban`]}
                  onChange={(e) => {
                    onRoadSpeedChange({
                      ...e,
                      target: {
                        ...e.target,
                        name: "urban",
                        roadCode,
                      },
                    });
                  }}
                />
              </View>
              <View className={styles.rowValue}>
                <MaskedTextField
                  mask={"99"}
                  value={rural}
                  name={`${roadCode}-rural`}
                  label={"Rural MPH"}
                  disabled={disabled}
                  error={errors[`${roadCode}-rural`]}
                  onChange={(e) => {
                    onRoadSpeedChange({
                      ...e,
                      target: {
                        ...e.target,
                        name: "rural",
                        roadCode,
                      },
                    });
                  }}
                />
              </View>
              <View className={styles.rowValue}>
                <MaskedTextField
                  mask={"99"}
                  value={routeConfig[roadCode].maxSpeed}
                  name={`${roadCode}-maxSpeed`}
                  label={"Max Speed"}
                  disabled={true}
                />
              </View>
            </View>
          );
        })}
      </View>
    </View>
  );
};
